import { Injectable, signal, OnDestroy, WritableSignal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ScreenService implements OnDestroy {
    isMobile: WritableSignal<boolean> = signal(false);
    isTablet: WritableSignal<boolean> = signal(false);
    isStandalone: WritableSignal<boolean> = signal(false);

    private resizeListener = () => this.checkScreenSize();

    constructor() {
        this.checkScreenSize();
        this.checkStandalone();
        window.addEventListener('resize', this.resizeListener);
    }

    private checkScreenSize() {
        const width = window.innerWidth;
        this.isMobile.set(width < 1024);
        this.isTablet.set(false); // Tablet mode removed, everything <1024 is mobile
    }

    private checkStandalone() {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || ('standalone' in navigator && (navigator as any).standalone === true);
        this.isStandalone.set(isStandalone);
    }

    ngOnDestroy() {
        window.removeEventListener('resize', this.resizeListener);
    }
}
